import { AddressAutoComplete } from '../modules/AddressAutoComplete';
import { createAddressSearch } from '../Maps/AddressSearch';
import { LocationFilterBase, type ExistingLocationFilter } from './LocationFilterBase';

export class FallbackLocationFilter extends LocationFilterBase {
    constructor(form: HTMLFormElement, existingFilter: ExistingLocationFilter) {
        super(form, existingFilter);

        const provider = createAddressSearch();
        const ac = new AddressAutoComplete(this.searchBar, provider);
        ac.setOnSelectCallback((place) => {
            this.latitudeHidden.value = place.latitude.toString();
            this.longitudeHidden.value = place.longitude.toString();
            this.addressHidden.value = place.formattedAddress;
        });
    }
}
